import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/dashboard/shared/PageHeader';
import { BookingSlotList } from '@/components/dashboard/booking-slots/BookingSlotList';
import { RiAddLine } from '@remixicon/react';
import { DashboardHead } from '@/components/SEO/DashboardHead';

export function BookingSlotsPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <DashboardHead pageName="Booking Slots" />
      <PageHeader
        title="Booking Slots"
        actions={
          <Button onClick={() => navigate('/dashboard/booking-slots/new')} className="h-auto gap-1 rounded-full !px-4 !py-2 text-sm font-semibold shadow-none">
            <RiAddLine className="h-4 w-4" />
            Add Slot
          </Button>
        }
      />
      <BookingSlotList />
    </div>
  );
}

